import React from 'react';
import PropTypes from "prop-types";

import Alert from 'react-bootstrap/Alert';
import ListGroup from 'react-bootstrap/ListGroup';

import {NextAction} from "../lib/Constants";
import {addLinkTargetsToHtmlString} from "../common/Utils";

const RegisterResult = (props) => {
    let alertVariant, componentPreText, componentPostText;

    let alertMessages;
    if (props.result.messages) {
        if (props.result.messages.length === 1) {
            alertMessages  = <p>{addLinkTargetsToHtmlString(props.result.messages[0].messageText)}</p>
        } else {
            let alertMessagesItems = props.result.messages.map((msg, index) => {
                return (
                    <li key={index}>
                        {addLinkTargetsToHtmlString(msg.messageText)}
                    </li>
                )
            });

            alertMessages =
                <ul className="list-unstyled">
                    {alertMessagesItems}
                </ul>
        }
    }

    switch (props.result.nextAction) {
        case NextAction.FAIL:
            alertVariant = "danger";
            componentPreText =
                <>
                    <p><strong>MyPlan was unable to register you for your sections.</strong></p>
                    <p>The Registration system gave the following errors:</p>
                </>
            componentPostText =
                <>
                    <p>Because one or more of your sections has an error, MyPlan can't register you for any of your sections.</p>
                    <p>This means that you have not been registered for any of the sections in this transaction.</p>
                    <p><strong>Next steps</strong></p>
                    <p>Right now: In your MyPlan Registration Preview, uncheck the checkbox next to each section that has an error. Then you will be able to register for the sections that don't have errors.</p>
                    <p>After that: Look at the error messages for each section and take action to resolve them. If you have any questions, contact your adviser.</p>
                </>
            break;
        case NextAction.SUCCESS:
            alertVariant = "success";
            componentPreText = <p>You are now registered for your selected sections.</p>
            break;
        default:
            alertVariant = "warning";
    }

    let registrationChanges;
    if (props.result.registrationChanges && props.result.registrationChanges.length > 0) {
        let registrationChangesList = [];

        props.result.registrationChanges.map((change, i) => {
            change.messages.map((msg, n) => {
                if (msg.messageText !== "") {
                    registrationChangesList.push(
                        <ListGroup.Item key={i+'-'+n}>
                            {addLinkTargetsToHtmlString(msg.messageText)}
                        </ListGroup.Item>
                    )
                }
            });
        });

        registrationChanges =
            <ListGroup className="mt-3">
                {registrationChangesList}
            </ListGroup>
    }

    return (
        <>
            {componentPreText}
            <Alert variant={alertVariant} className="alert-no-icon my-3">
                {alertMessages}
                {registrationChanges}
            </Alert>
            {componentPostText}
        </>
    );
}

RegisterResult.propTypes = {
    result: PropTypes.object.isRequired
}

export default RegisterResult;